import { mapListToRecords, normalizeList } from '@sophocles/entities/entityUtils';
import { WarrantyStatus, warrantyStatusSchema } from '@sophocles/entities/WarrantyStatus/warrantyStatusRecord';
import apiClient from '@sophocles/http-common';
import { checkHttpStatus, genericErrorAction } from '@sophocles/utils';
import { fromJS } from 'immutable';
import { normalize } from 'normalizr';

/* Receive Actions */
export const RECEIVE_WARRANTY_STATUSES = 'RECEIVE_WARRANTY_STATUSES';
function receiveWarrantyStatuses(json) {
  return {
    type: RECEIVE_WARRANTY_STATUSES,
    warrantyStatuses: mapListToRecords(json, WarrantyStatus),
  };
}

/* Request Actions */
// starter request
export const REQUEST_WARRANTY_STATUS = 'REQUEST_WARRANTY_STATUS';
function requestWarrantyStatus(warrantyStatus_id) {
  return {
    type: REQUEST_WARRANTY_STATUS,
    warrantyStatus_id,
  };
}

export const REQUEST_ALL_WARRANTY_STATUSES = 'REQUEST_ALL_WARRANTY_STATUSES';
function requestAllWarrantyStatuses() {
  return {
    type: REQUEST_ALL_WARRANTY_STATUSES,
  };
}

/* Fetch Actions */
// starter fetch

export function fetchWarrantyStatus(warrantyStatus_id) {
  return dispatch => {
    dispatch(requestWarrantyStatus(warrantyStatus_id));
    return apiClient
      .get(`/warrantystatuses/${warrantyStatus_id}/`)
      .then(checkHttpStatus)
      .then(response => normalizeList(response.data, 'warrantyStatuses', warrantyStatusSchema))
      .then(json => dispatch(receiveWarrantyStatuses(json.entities.warrantyStatuses)))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_WARRANTY_STATUS)));
  };
}

export function fetchAllWarrantyStatuses() {
  return dispatch => {
    dispatch(requestAllWarrantyStatuses());
    return apiClient
      .get(`/warrantystatuses/?limit=10000`)
      .then(checkHttpStatus)
      .then(response => normalizeList(response.data.results, 'warrantyStatuses', warrantyStatusSchema))
      .then(json => dispatch(receiveWarrantyStatuses(json.entities.warrantyStatuses)))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_WARRANTY_STATUS)));
  };
}
// USED IN WARRANTY STATUS TABLE CALL
export function rawFetchAllWarrantyStatus() {
  return dispatch => {
    dispatch(requestAllWarrantyStatuses());
    return apiClient
      .get(`/warrantystatuses/?limit=10000`)
      .then(checkHttpStatus)
      .then(response => fromJS(response.data.results))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_WARRANTY_STATUS)));
  };
}

/* Edit Actions */
export const EDIT_WARRANTY_STATUS = 'EDIT_WARRANTY_STATUS';
export function editWarrantyStatus(warrantyStatus_id) {
  return {
    type: EDIT_WARRANTY_STATUS,
    warrantyStatus: warrantyStatus_id,
  };
}

export function patchWarrantyStatus(warrantyStatus_id, values) {
  return dispatch => {
    dispatch(editWarrantyStatus(warrantyStatus_id));
    return apiClient
      .patch(`/warrantystatuses/${warrantyStatus_id}/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, warrantyStatusSchema))
      .then(json => dispatch(receiveWarrantyStatuses(json.entities.warrantyStatuses)))
      .catch(error => dispatch(genericErrorAction(error, EDIT_WARRANTY_STATUS)));
  };
}

/* Create Actions */
export const CREATE_WARRANTY_STATUS = 'CREATE_WARRANTY_STATUS';
function sayCreateWarrantyStatus(values) {
  return {
    type: CREATE_WARRANTY_STATUS,
    values: values,
  };
}

export function createWarrantyStatus(values) {
  return dispatch => {
    dispatch(sayCreateWarrantyStatus(values));
    return apiClient
      .post(`/warrantystatuses/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, warrantyStatusSchema))
      .then(json => dispatch(receiveWarrantyStatuses(json.entities.warrantyStatuses)))
      .catch(error => dispatch(genericErrorAction(error, CREATE_WARRANTY_STATUS)));
  };
}

/* Delete Actions */
export const DELETE_WARRANTY_STATUS = 'DELETE_WARRANTY_STATUS';
function sayDeleteWarrantyStatus(warrantyStatus_id) {
  return {
    type: DELETE_WARRANTY_STATUS,
    warrantyStatus: warrantyStatus_id,
  };
}

export function deleteWarrantyStatus(warrantyStatus_id) {
  return dispatch =>
    apiClient
      .delete(`/warrantystatuses/${warrantyStatus_id}/`)
      .then(checkHttpStatus)
      .then(r => dispatch(sayDeleteWarrantyStatus(warrantyStatus_id)))
      .catch(error => dispatch(genericErrorAction(error, DELETE_WARRANTY_STATUS)));
}
